/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import r from"../../../../core/Logger.js";const o=()=>r.getLogger("esri.views.3d.support.buffer.math");function t(r,o,t){if(o<=0)return 0;const e=r-t;return e<0?0:Math.floor(e/o)+1}export{t as getCount,o as getMathLogger};
